export enum ActionTypes {
  SHOW_BANNER_PLACEMENT_SUCCESS = "@@banner_placement/SHOW_BANNER_PLACEMENT_SUCCESS",
  SHOW_BANNER_PLACEMENT_FAILURE = "@@banner_placement/SHOW_BANNER_PLACEMENT_FAILURE",
  SHOW_BANNER_PLACEMENT_REQUEST = "@@banner_placement/SHOW_BANNER_PLACEMENT_REQUEST",
}
